interface PanelHeaderProps {
  title: string;
  count: number;
}

export const PanelHeader = (props: PanelHeaderProps) => {
  const { title, count } = props;

  return (
    <span className="text-[var(--fett-text-primary)]">
      {title}
      <span className="ml-1">({count})</span>
    </span>
  );
};
